import styled from '@emotion/styled';
import { Col } from 'antd';

export const SadaServiceAppointmentCard = styled(Col)``;
